import React, { useMemo } from 'react';
import { useBoardChartData } from '../../hooks/useBoardChartData';
import { BaseChartProps } from './types';
import { CHART_COLORS, getCurrencySymbol, formatCompactNumber } from './chartTheme';
import { useSetChartMetadata } from './ChartContext';

export const TotalExpensesChart: React.FC<BaseChartProps> = () => {
    const { finance, currencySettings } = useBoardChartData();

    const currencySymbol = useMemo(
        () => getCurrencySymbol(currencySettings?.default),
        [currencySettings?.default]
    );

    const totalExpenses = useMemo(
        () => finance?.totalExpenses ?? 0,
        [finance?.totalExpenses]
    );

    const isEmpty = useMemo(() => !finance || totalExpenses === 0, [finance, totalExpenses]);

    useSetChartMetadata({ isEmpty });

    return (
        <div className="flex h-full w-full items-center justify-center [container-type:inline-size]">
            <p
                className="font-semibold text-center"
                style={{
                    color: CHART_COLORS.expense,
                    fontSize: 'clamp(1.25rem, 8cqi, 2.5rem)',
                }}
            >
                {formatCompactNumber(totalExpenses, currencySymbol)}
            </p>
        </div>
    );
};
